export default {"src":"/_next/static/media/male_6.e10731ae.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};